<template>
  <div id="app">
    <div id="nav">
      <router-link to="/"></router-link>
    </div>
    <keep-alive include="secondBar,choose_med" v-if="isRouterAlive">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
// import VConsole from 'vconsole';

export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    // new VConsole();
    // var vConsole = new VConsole();
    // console.log("111 :>> ", 111);
    // window.onload = function() {
    //   document.addEventListener("touchstart", function(event) {
    //     if (event.touches.length > 1) {
    //       event.preventDefault();
    //     }
    //   });
    //   document.addEventListener("gesturestart", function(event) {
    //     event.preventDefault();
    //   });
    // };
  },
  methods: {
    reload() {
      //在写到需要刷新的页面时，在页面app.vue组建提供的provid的reload依赖，在逻辑完成后（添加或删除），直接this.reload调用，即可刷新当前页面
      //在需要的页面用inject 注册
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  // -webkit-font-smoothing antialiased
  // -moz-osx-font-smoothing grayscale
  text-align center
  background #efefef
  height 100%
</style>
